export default __webpack_public_path__ + "static/media/prospecting-ad-preview.e9787dcc.gif";